export default "__VITE_PUBLIC_ASSET__859e685f__"